import React, { useEffect, useState, useRef, lazy } from 'react';
import { motion } from 'framer-motion';
import { useInView } from '../hooks/useInView';
export function LifestyleSection() {
  const [ref, isInView] = useInView({
    threshold: 0.15
  });
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const toggleAudio = () => {
    if (!audioRef.current) return;
    if (isPlaying) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      setIsPlaying(false);
    } else {
      audioRef.current.volume = 0.23;
      audioRef.current.play().then(() => {
        setIsPlaying(true);
      }).catch(e => console.error('Audio playback failed:', e));
    }
  };
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;
    // Set volume to 15% higher than background audio (0.2 * 1.15 = 0.23)
    audio.volume = 0.23;
    const handleEnded = () => {
      setIsPlaying(false);
      audio.currentTime = 0;
    };
    audio.addEventListener('ended', handleEnded);
    return () => audio.removeEventListener('ended', handleEnded);
  }, []);
  return <section className="py-10 sm:py-24 relative bg-[#0A0A0B] overflow-hidden border-t border-white/5" style={{
    contentVisibility: 'visible',
    containIntrinsicSize: 'auto'
  }} data-id="element-237">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-238">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8
      }} className="relative rounded-2xl overflow-hidden border border-white/10 shadow-[0_20px_60px_rgba(0,0,0,0.6)] aspect-[1024/600] bg-[#0c0c0e]" data-id="element-239">
          <img src="https://cdn.shopify.com/s/files/1/0981/0781/8286/files/ChatGPT_Image_26_abr_2026_06_26_30_a.m.3.png?v=1777199448" alt="Persona usando el sistema El Código 888" width="1024" height="600" sizes="(max-width: 1024px) 100vw, 1024px" className="absolute inset-0 w-full h-full object-cover" loading="lazy" decoding="async" data-id="element-240" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0B] via-transparent to-transparent pointer-events-none" data-id="element-241" />

          <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-10 text-center" data-id="element-242">
            <p className="text-white/80 text-sm sm:text-lg font-medium max-w-lg mx-auto" data-id="element-243">
              Un sistema que se integra en tu día a día, sin complicaciones, sin
              teoría innecesaria.
            </p>
          </div>
        </motion.div>

        {/* Premium Audio Activation Element */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mt-10 sm:mt-16 flex flex-col items-center text-center" data-id="element-244">
          <div className="relative mb-3" data-id="element-245">
            <div className="absolute inset-0 bg-gold/20 blur-xl sm:blur-2xl rounded-full animate-pulseGlow pointer-events-none" data-id="element-246" />
            <h3 className="relative text-gold font-black text-2xl sm:text-3xl uppercase tracking-widest drop-shadow-md" data-id="element-247">
              ESPERA...
            </h3>
          </div>

          <p className="text-white/80 text-base sm:text-lg mb-6 font-medium" data-id="element-248">
            Haz una pausa. Activa tu primer momento de enfoque.
          </p>

          <div className="h-px w-24 bg-gold/50 mb-8" data-id="element-249" />

          <button onClick={toggleAudio} className="group relative flex items-center justify-center gap-3 bg-black border border-gold/60 text-gold font-bold uppercase tracking-wider px-8 py-3.5 sm:py-4 rounded-full min-h-[48px] hover:shadow-[0_0_15px_rgba(212,175,55,0.3)] hover:scale-105 active:scale-95 transition-all duration-300" data-id="element-250">
            {isPlaying ? <>
                <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor" className="text-gold" data-id="element-251">
                  <rect x="2" y="2" width="10" height="10" data-id="element-252" />
                </svg>
                <span data-id="element-253">STOP</span>
              </> : <>
                <svg width="14" height="16" viewBox="0 0 14 16" fill="currentColor" className="text-gold translate-x-[1px]" data-id="element-254">
                  <path d="M2 2L12 8L2 14V2Z" data-id="element-255" />
                </svg>
                <span data-id="element-256">PLAY</span>
              </>}
          </button>

          <audio ref={audioRef} src="https://cdn.shopify.com/s/files/1/0981/0781/8286/files/Soy_un_iman_para_la.mp3?v=1777435974" preload="none" data-id="element-257" />
        </motion.div>
      </div>
    </section>;
}